import { render, staticRenderFns } from "./ModalComments.vue?vue&type=template&id=452a25c6&"
import script from "./ModalComments.vue?vue&type=script&lang=js&"
export * from "./ModalComments.vue?vue&type=script&lang=js&"
import style0 from "./ModalComments.vue?vue&type=style&index=0&id=452a25c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports